var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{ [_vm.s.positive]: _vm.sign === '' || _vm.sign === '+', [_vm.s.negative]: _vm.sign === '-', [_vm.textClass]: _vm.textClass }},[_vm._v(" "+_vm._s(_vm.sign)+_vm._s(_vm.moduledValue)+_vm._s(_vm.postfix)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }